import * as React from 'react';

export const LabelledAttribute = ({ label, attribute }: { label: string; attribute?: React.ReactChild }) => (
  <div className="labelled-attribute">
    <strong>{label}: </strong>
    <span>{attribute}</span>
  </div>
);
